import React from 'react';
import css from 'styled-jsx/css';
import ButtonBecomeCreator from '../ButtonBecomeCreator';
import config from '~/config';
import themeVariables from '~/shared/themeVariables';
import { SERVICE_TYPES } from '~/utils/constants';
import I18nLink from '~/components/I18nLink';

const LOGO_BY_SERVICE_TYPE = {
  [SERVICE_TYPES.PHOTO_AC]: `${config.staticPrefix}/static/assets/image/logo/logo_photo_ac.svg`,
  [SERVICE_TYPES.ILLUST_AC]: `${config.staticPrefix}/static/assets/image/logo/logo_illust.svg`,
};

const Banner = ({ t, title }) => {
  return (
    <div className="banner">
      <div className="container-banner">
        <I18nLink href="/">
          <a className="img-logo-wrapper">
            <img
              className="img-logo lazyload"
              data-srcset={LOGO_BY_SERVICE_TYPE[config.serviceType]}
              alt="site logo"
            />
          </a>
        </I18nLink>
        <div className="overlay">
          <h1 className="heading">
            {title || t('photoac_landing_page_heading_banner')}
          </h1>
          <h2 className="subheading">
            {t('photoac_landing_page_content_banner')}
          </h2>
          <ButtonBecomeCreator
            t={t}
            style={{ marginTop: themeVariables.space.base }}
          />
        </div>
        {config.isPhotoAC() ? (
          <>
            <img
              className="img-banner-01 lazyload "
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac-banner.png`}
            />
            <img
              className="img-banner-ipad lazyload "
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac-banner-ipad.png`}
            />
          </>
        ) : (
          <>
            <img
              className="img-banner-01 lazyload "
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_banner.png`}
            />
            <img
              className="img-banner-ipad lazyload "
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_banner.png`}
            />
          </>
        )}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

const styles = css`
  .banner {
    position: relative;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .container-banner {
    width: 100%;
    max-width: 1248px;
    display: flex;
    flex-direction: row;
    // background: red;
    position: relative;
  }

  .img-banner-01 {
    position: relative;
    width: inherit;
    margin-bottom: -10%;
  }
  .img-banner-ipad {
    display: none;
  }
  .img-logo-wrapper {
    position: absolute;
    display: flex;
    flex-direction: column;
    z-index: 1;
    cursor: pointer;
  }
  .overlay {
    position: absolute;
    width: 52%;
    left: 0;
    // background: rgba(47, 59, 51, 0.5);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;
    padding-bottom: 20%;
    z-index: 800;
    top: 25%;
  }

  .heading {
    font-size: 34px;
    padding: 0;
    text-align: left;
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    letter-spacing: -0.03em;
    color: #1b2833;
  }

  .subheading {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: -0.03em;
    color: #1b2833;
  }
  @media screen and (min-width: 905px) and (max-width: 1239px) {
    .container-banner {
      padding: 0 32px;
    }
    .overlay {
      width: 50%;
      padding-left: 32px;
    }
  }
  @media screen and (min-width: 730px) and (max-width: 904px) {
    .container-banner {
      padding: 0 16px;
    }
    .heading {
      font-size: 44px;
    }

    .subheading {
      font-size: 24px;
    }
    .img-banner-01 {
      display: none;
    }
    .img-banner-ipad {
      display: block;
      width: inherit;
    }
    .overlay {
      top: 20%;
      margin-left: 16px;
      width: 44%;
    }
  }
`;

export default Banner;
